import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function StarRateIcon(props: IconProps) {
    return <Icon {...props} iconKey={"star_rate"}/>
}
